<template>
    <vx-card title="Добавление пикселя" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.sspIdsStr"
                        :danger="!!errors.sspIds"
                        :danger-text="errors.sspIds"
                        autocomplete="off"
                        label="Список SSP"
                        placeholder="Введите список SSP (через запятую)..."
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.pixel"
                        :danger="!!errors.pixel"
                        :danger-text="errors.pixel"
                        autocomplete="off"
                        label="Пиксель"
                        placeholder="Введите ссылку на пиксель..."
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.percent"
                        :danger="!!errors.percent"
                        :danger-text="errors.percent"
                        type="number"
                        autocomplete="off"
                        label="Процент трафика"
                        placeholder="Укажите процент трафика..."
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveSspPixel()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
    import vSelect from 'vue-select';
    import axios from 'axios';

    export default {
        name: 'ssp-pixel-create',
        data() {
            return {
                sspPixel: undefined,
                form: {
                    pixel: undefined,
                    percent: undefined,
                    sspIdsStr: undefined
                },
                errors: {
                    pixel: '',
                    percent: '',
                    sspIdsStr: ''
                }
            }
        },
        components: {
            'v-select': vSelect
        },
        methods: {
            saveSspPixel() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                let sspIdsParsed = [];
                const sspIdsParts = this.form.sspIdsStr
                    .split(',')
                    .filter(i => i != "");
                if (sspIdsParts && sspIdsParts.length > 0) {
                    sspIdsParts.forEach(i => {
                        if (!Number.isInteger(Number(i))){
                            error = 'Введен некорректный список SSP.';
                        } else {
                            sspIdsParsed.push(i.trim());
                        }
                    });
                }

                const params = Object.assign({}, this.form, { sspIds: sspIdsParsed });

                this.$axios({
                    method: 'POST',
                    url: 'ssp-pixel',
                    params: params,
                    errors: this.errors,
                    success: (user) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Успешно добавлено",
                            text: "Пиксель успешно добавлен",
                            color: "success",
                        });
                        this.$router.push('/ssp-pixels');
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при добавлении пикселя!",
                            color: "danger",
                        });
                    }
                })
            },
            cancelEdit() {
                this.$router.push('/ssp-pixels');
            }
        },
        mounted() {
        }
    }
</script>

<style>
    .select-error > div {
        border: 1px solid rgba(var(--vs-danger),1)!important;
    }
</style>